import DashboardLayout from "../../components/dashboard/DashboardLayout";
import DatabaseBackupManager from "../../components/dashboard/DatabaseBackupManager";

export default function DatabaseBackupPage() {
  return (
    <DashboardLayout>
      <DatabaseBackupManager />
    </DashboardLayout>
  );
}
